module.exports = __webpack_public_path__ + "static/media/SplashScreen.c0ec0049.png";